define('modules/reporting/campaigns/technology/views/columnSelector',["T1ColumnSortable"], function (ColumnSortable) {
  "use strict";

  return ColumnSortable.extend({});
});
